import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const putCurrency = (params) => {
    return axios.put(`${backendHost}/api/admin/currency/${params.id}`);
};
